import { AppSettingsConfig } from 'src/app/config/app-settings.config';
import { ICustomControl } from '../models/form.model';
import { ValidationEnum } from '../models/validation.model';
import { DateHelperService } from '../services/helpers/date-helper.service';

export const towerStatuses = [
	{
		value: 0,
		name: 'OPEN'
	},
	{
		value: 1,
		name: 'CLOSED'
	},
	{
		value: 2,
		name: 'ROTATING'
	},
	{
		value: 3,
		name: 'LOCKED'
	},
	{
		value: 4,
		name: 'OFFLINE'
	}
];

export const boxStatuses = [
	{
		value: 'FREE',
		name: 'FREE'
	},
	{
		value: 'OUT_OF_ORDER',
		name: 'OUT_OF_ORDER'
	},
	{
		value: 'OCCUPIED',
		name: 'OCCUPIED'
	}
];
export const genders = [
	{
		value: 'FEMALE',
		name: 'FEMALE'
	},
	{
		value: 'MALE',
		name: 'MALE'
	},
	{
		value: 'UNKNOWN',
		name: 'UNKNOWN'
	},
]
export const Forms = {
	forgotPassword: [
		{
			id: 'email',
			type: 'email',
			label: 'Email',
			validators: [
				'required',
				'email',
				ValidationEnum.Pattern],
			errors: {
				required: 'required',
				email: 'email',
				pattern: ValidationEnum.Pattern
			}
		}
	],

	changePassword: [
		{
			id: 'currentPassword',
			type: 'password',
			label: 'users.form.password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required
			],
			errors: {
				required: ValidationEnum.Required
			}
		},

		{
			id: 'password',
			type: 'password',
			label: 'auth.password-reset.new-password',
			focused: false,
			showVisibleToggle: true,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.Pattern
			],
			errors: {
				required: ValidationEnum.Required,
				pattern: ValidationEnum.Pattern
			}
		},
		{
			id: 'confirmPassword',
			type: 'password',
			label: 'auth.change-password.confirm-new-password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.NotSame,
				// ValidationEnum.Pattern
			],
			errors: {
				required: ValidationEnum.Required,
				notSame: ValidationEnum.NotSame,
				// pattern: ValidationEnum.Pattern

			}
		},
	],

	newPassword: [
		{
			id: 'password',
			type: 'password',
			label: 'users.form.password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.Pattern
			],
			errors: {
				required: ValidationEnum.Required,
				pattern: ValidationEnum.Pattern
			}
		},
		{
			id: 'confirmPassword',
			type: 'password',
			label: 'users.form.confirm-password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.NotSame,
				// ValidationEnum.Pattern
			],
			errors: {
				required: ValidationEnum.Required,
				notSame: ValidationEnum.NotSame,
				// pattern: ValidationEnum.Pattern

			}
		},
	],

	signIn: [
		{
			id: 'email',
			type: 'email',
			label: 'auth.login.form.email.label',
			autocomplete: 'email',
			// icon: 'ni ni-email-83',
			focused: false,
			validators: [
				'required',
				// 'email'
			],
			errors: {
				required: 'required',
				// email: 'email'
			}
		},
		{
			id: 'password',
			type: 'password',
			autocomplete: 'current-password',
			showVisibleToggle: true,
			// icon: 'ni ni-lock-circle-open',
			label: 'auth.login.form.password.label',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		}
	],


	editPhoneEmail: [
		{
			id: 'email',
			type: 'email',
			label: 'users.form.email',
			focused: false,
			isVerified: false,
			validators: ['required', 'email'],
			errors: {
				required: 'required',
				email: 'email'
			}
		},

		{
			id: 'phoneCountryCode',
			type: 'text',
			label: 'users.form.phone',
			clazz: 'select-input',
			isSelect: true,
			selectData: [],
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'phoneMobile',
			type: 'tel',
			label: 'users.form.phone',
			clazz: 'col select-input',
			isVerified: false,
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
	] as Array<ICustomControl>,

	signUp: [
		{
			id: 'id',
			type: 'text',
			label: 'Id',
			focused: false,
			hide: true
		},
		{
			id: 'firstName',
			type: 'text',
			label: 'users.form.first-name',
			autocomplete: 'name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'lastName',
			type: 'text',
			autocomplete: 'family-name',
			label: 'users.form.last-name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'phoneCountryCode',
			type: 'text',
			label: 'users.form.phone',
			clazz: 'select-input pl-16px',
			isPhoneSelect: true,
			autocomplete: 'off',
			selectData: [],
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'phoneMobile',
			type: 'tel',
			autocomplete: 'tel-national',
			// label: ' ',
			label: 'users.form.phone',
			clazz: 'col select-input right-part',
			isVerified: false,
			focused: false,
			hideLabel: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'email',
			type: 'email',
			autocomplete: 'email',
			label: 'users.form.email',
			focused: false,
			isVerified: false,
			validators: ['required', 'email'],
			errors: {
				required: 'required',
				email: 'email'
			}
		},
		{
			id: 'password',
			type: 'password',
			label: 'users.form.password',
			autocomplete: 'new-password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.Pattern
			],
			errors: {
				required: ValidationEnum.Required,
				pattern: ValidationEnum.Pattern

			}
		},
		{
			id: 'confirmPassword',
			type: 'password',
			autocomplete: 'new-password',
			label: 'users.form.confirm-password',
			showVisibleToggle: true,
			focused: false,
			validators: [
				ValidationEnum.Required,
				ValidationEnum.NotSame,
			],
			errors: {
				required: ValidationEnum.Required,
				notSame: ValidationEnum.NotSame,
			}
		},

		{
			id: 'privacy',
			type: 'checkbox',
			labels: [
				'users.form.agree-with',
				'users.form.privacy-policy',
				'users.form.zu'
			],
			url: AppSettingsConfig.privacyPolicy,
			clazz: 'col-12',
			focused: false,
		},

		{
			id: 'terms',
			type: 'checkbox',
			clazz: 'col-12',
			labels: [
				'users.form.agree-with',
				'users.form.terms-and-conditions',
				'users.form.zu'
			],
			url: AppSettingsConfig.termsAndConditions,
			translatedUrlParts: [],
			focused: false,
		},
	] as Array<ICustomControl>,

	signUpSocialLogin: [
		{
			id: 'id',
			type: 'text',
			label: 'Id',
			focused: false,
			hide: true
		},
		{
			id: 'firstName',
			type: 'text',
			label: 'users.form.first-name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'lastName',
			type: 'text',
			label: 'users.form.last-name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'email',
			type: 'email',
			label: 'users.form.email',
			focused: false,
			isVerified: false,
			validators: ['required', 'email'],
			errors: {
				required: 'required',
				email: 'email'
			}
		},
		{
			id: 'phoneCountryCode',
			type: 'text',
			label: 'users.form.phone',
			clazz: 'select-input pl-16px',
			isPhoneSelect: true,
			selectData: [],
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'phoneMobile',
			type: 'tel',
			label: 'users.form.phone',
			clazz: 'col select-input right-part',
			isVerified: false,
			focused: false,
			hideLabel: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'privacy',
			type: 'checkbox',
			labels: [
				'users.form.agree-with',
				'users.form.privacy-policy',
				'users.form.zu'
			],
			url: AppSettingsConfig.privacyPolicy,
			clazz: 'col-12',
			focused: false
		},

		{
			id: 'terms',
			type: 'checkbox',
			clazz: 'col-12',
			labels: [
				'users.form.agree-with',
				'users.form.terms-and-conditions',
				'users.form.zu'
			],
			url: AppSettingsConfig.termsAndConditions,
			translatedUrlParts: [],
			focused: false
		},
	] as Array<ICustomControl>,

	user: [
		{
			id: 'id',
			type: 'text',
			label: 'Id',
			focused: false,
			hide: true,
		},
		{
			id: 'firstName',
			type: 'text',
			label: 'users.form.first-name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'lastName',
			type: 'text',
			label: 'users.form.last-name',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'email',
			type: 'email',
			label: 'users.form.email',
			focused: false,
			isVerified: true,
			validators: ['required', 'email'],
			errors: {
				required: 'required',
				email: 'email'
			}
		},

		{
			id: 'phoneCountryCode',
			type: 'text',
			label: 'users.form.phone',
			clazz: 'select-input pl-16px',
			isPhoneSelect: true,
			selectData: [],
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'phoneMobile',
			type: 'tel',
			label: 'users.form.phone',
			clazz: 'col select-input right-part',
			isVerified: false,
			focused: false,
			hideLabel: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},

		{
			id: 'gender',
			type: 'text',
			label: 'users.form.gender',
			isSelect: true,
			selectData: genders,
			focused: false,
			// validators: ['required'],
			// errors: {
			// 	required: 'required'
			// }
		},

		{
			id: 'address',
			type: 'text',
			label: 'users.form.address',
			focused: false,
			clazz: 'col-12',
			// validators: ['required'],
			// errors: {
			// 	required: 'required',
			// }
		},
		{
			id: 'address2',
			type: 'text',
			label: 'users.form.address2',
			focused: false,
			clazz: 'col-12'
		},
		{
			id: 'city',
			type: 'text',
			label: 'users.form.city',
			focused: false,
			clazz: 'col-md-6 col-12',
			// validators: ['required'],
			// errors: {
			// 	required: 'required',
			// }
		},

		{
			id: 'postCode',
			type: 'text',
			label: 'users.form.post-code',
			clazz: 'col-md-6 col-12',
			focused: false,
			// validators: ['required'],
			// errors: {
			// 	required: 'required'
			// }
		},
		{
			id: 'countryCode',
			type: 'text',
			label: 'users.form.country',
			clazz: 'col-md-6 col-12',
			isSelect: true,
			selectData: [],
			focused: false,
			// validators: ['required'],
			// errors: {
			// 	required: 'required'
			// }
		},
		{
			id: 'createdDate',
			type: 'text',
			isTextarea: true,
			label: 'Created Date',
			focused: false,
			hide: true
		},
		{
			id: 'language',
			type: 'text',
			label: 'users.form.language',
			clazz: 'col-md-6 col-12',
			isSelect: true,
			selectData: [],
			focused: false,
			// validators: ['required'],
			// errors: {
			// 	required: 'required'
			// }
		},

	] as Array<ICustomControl>,

	box: [
		{
			id: 'id',
			type: 'text',
			label: 'Id',
			focused: false,
			hide: true,
			readonly: true,
			// validators: ['required'],
			// errors: {
			//   required: 'required'
			// }
		},
		{
			id: 'box',
			type: 'text',
			label: 'Box',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'tower',
			type: 'text',
			label: 'Tower',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'group',
			type: 'text',
			label: 'Group',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'towerStatus',
			type: 'text',
			label: 'Tower Status',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},

		{
			id: 'status',
			type: 'text',
			label: 'Box Status',
			isSelect: true,
			selectData: boxStatuses,
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'comment',
			type: 'text',
			isTextarea: true,
			label: 'Why?',
			focused: false,
			clazz: 'col-12',
			validators: ['required'],
			errors: {
				required: 'required'
			}
		}
	] as Array<ICustomControl>,

	booking: [
		{
			id: 'id',
			type: 'text',
			label: 'ID',
			readonly: true,
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},

		{
			id: 'bookingStatus',
			type: 'text',
			label: 'Status',
			readonly: true,
			focused: false
		},

		{
			id: 'startDate',
			type: 'text',
			label: 'Start Date',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'endDate',
			type: 'text',
			label: 'End Date',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'group',
			type: 'text',
			label: 'Group',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'tower',
			type: 'text',
			label: 'Tower',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},


		{
			id: 'box',
			type: 'text',
			label: 'Box',
			readonly: true,
			focused: false
		},

		{
			id: 'user',
			type: 'text',
			label: 'User',
			focused: false,
			readonly: true,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},


	] as Array<ICustomControl>,

	payment: [
		{
			id: 'name',
			type: 'text',
			label: 'payment.form.card-holder',
			clazz: 'col-12',
			focused: false,
			validators: ['required'],
			errors: {
				required: 'required'
			}
		},
		{
			id: 'address_zip',
			type: 'text',
			label: 'users.form.post-code',
			focused: false,
			clazz: 'col-12'
		},
		{
			id: 'address_country',
			type: 'text',
			label: 'users.form.country',
			focused: false,
			clazz: 'col-12',
			isSelect: true,
			selectData: [],
		},

		{
			id: 'amount',
			type: 'text',
			label: 'Amount',
			focused: false,
			clazz: 'col-12',
			isSelect: true,
			selectData: [],
		},

		{
			id: 'setup_future_usage',
			type: 'checkbox',
			label: 'Active',
			focused: false,
			hide: true
		}
	] as Array<ICustomControl>,

	voucher: [
		{
			id: 'value',
			type: 'text',
			label: 'my-free-hours.voucher-code',
			clazz: 'col-12',
			focused: false,
			minLength: 5,
			maxLength: 12,
			validators: ['required', ValidationEnum.MinLength, ValidationEnum.MaxLength],
			errors: {
				required: 'required',
				minLength: 'minlength',
				maxLength: 'maxlength'

			}
		}
	] as Array<ICustomControl>,

	sharedBooking: [
		{
			id: 'id',
			type: 'text',
			label: 'ID',
			readonly: true,
			focused: false,
			hide: true
		},
		// {
		// 	id: 'status',
		// 	type: 'text',
		// 	label: 'share-access.table.status',
		// 	readonly: true,
		// 	focused: false
		// },
		{
			id: 'email',
			type: 'email',
			label: 'users.form.email',
			focused: false,
			validators: [ValidationEnum.Required, ValidationEnum.Email],
			errors: {
				required: ValidationEnum.Required, email: ValidationEnum.Email
			}
		},
		{
			id: 'startDate',
			type: 'date',
			label: 'share-access.form.start-date',
			focused: false,
			readonly: true,
			datepicker: true,
			placeholder: 'share-access.placeholder.select-date',
			datepickerFormat: 'date-time',
			validators: [
				ValidationEnum.StartDate,
				ValidationEnum.Required
			],
			errors: {
				startdate: ValidationEnum.StartDate,
				required: ValidationEnum.Required,
			}
		},
		{
			id: 'endDate',
			type: 'date',
			label: 'share-access.form.end-date',
			clazz: 'col-12 mt-3',
			focused: false,
			readonly: true,
			datepicker: true,
			placeholder: 'share-access.placeholder.select-date',
			datepickerFormat: 'date-time',
			validators: [ValidationEnum.Required],
			errors: {
				required: ValidationEnum.Required
			}
		},
		{
			id: 'multipleUse',
			switcher: true,
			type: 'text',
			focused: false,
			readonly: true,
			validators: [ValidationEnum.Required],
			errors: {
				required: ValidationEnum.Required
			}
		},
		{
			id: 'singleUse',
			switcher: true,
			type: 'text',
			focused: false,
			readonly: true,
			hide: true
		}
	] as Array<ICustomControl>,
	filter: [
		{
			id: 'sort',
			type: 'text',
			focused: false,
			readonly: true,
		},
	] as Array<ICustomControl>,
};
